import React, {useState} from 'react';
import NewFolderIcon from '@mui/icons-material/CreateNewFolder';
import {useTranslation} from "react-i18next";
import CreateNewFolderModal from "../modals/CreateNewFolderModal";
import Folder from "../../../../../models/Folder";
import {AssetBoxContainer, AssetBoxWrapper, AssetLabel} from "./AssetBoxStyle";


interface AssetBoxUploadProps {
    parentFolderId: string;
    onNewFolderCreated: (folder: Folder) => void;
}

const AssetBoxNewFolder: React.FC<AssetBoxUploadProps> = ({
                                                              parentFolderId,
                                                              onNewFolderCreated
                                                          }) => {
    const {t} = useTranslation();

    const [isModalOpen, setModalOpen] = useState(false);

    // Function to handle opening the modal
    const handleOpenModal = () => {
        setModalOpen(true);
    };

    // Function to handle closing the modal
    const handleCloseModal = () => {
        setModalOpen(false);
    };

    return (
        <>

            <AssetBoxContainer
                item
                xs={4}
                md={3}
            >
                <AssetBoxWrapper
                    onClick={handleOpenModal}
                >

                    <NewFolderIcon
                        sx={{
                            width: "50px",
                            height: "50px",
                            display: "block",
                            objectFit: "contain",
                            margin: "auto",
                            color: "black"
                        }}
                    />
                </AssetBoxWrapper>
                <AssetLabel>
                    {t("editor.select.newFolder")}
                </AssetLabel>
            </AssetBoxContainer>

            {isModalOpen && <CreateNewFolderModal
                parentFolderId={parentFolderId}
                open={isModalOpen}
                onClose={handleCloseModal}
                onFolderCreated={(folder) => {
                    onNewFolderCreated(folder);
                    handleCloseModal(); // Close the modal after folder creation
                }}
            />}
        </>
    );
};

export default AssetBoxNewFolder;
